module.exports = __webpack_public_path__ + "static/ddtsi-insignia-024583b3b0ad12411534e8f0ded53611.svg";